import { render, staticRenderFns } from "./iconNoReviews.vue?vue&type=template&id=e091230c&scoped=true"
import script from "./iconNoReviews.vue?vue&type=script&lang=js"
export * from "./iconNoReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e091230c",
  null
  
)

export default component.exports